import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import ContentGroupsPhasesForm from './../../elements/phases/groups';
import Loading from "../../elements/loading";
import GroupsAdd from './../../elements/phases/widget/groups_add';

class GroupPhaseEdit extends Component {
	render() {
		const { groupsPhases } = this.props;
		return (
			groupsPhases.isFetching ? <Loading/>:<ContentGroupsPhasesForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.fetchStatus();
		this.props.resetGroupsPhases();
	}
}

export default BaseLayout(GroupPhaseEdit, {
	title:"Crear proceso",
	subnav: {
		icon: 'fa-sliders',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <GroupsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/group_phases/create.jsx